
import mixinFlex from './mixin-flex'

export default {
  name: 'VsFlexRow',
  mixins: [
    mixinFlex
  ],
  props: {
    wrap: {
      type: [Boolean, String, Object],
      default: true
    },
    items: {
      type: [String, Object],
      default: 'stretch'
    },
    columns: {
      type: [String, Number, Object],
      default: null
    },
    autoFill: {
      type: [String, Object],
      default: null
    },
    gap: {
      type: [Boolean, String, Number, Object],
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    default: {
      $attrs: ['overflow'],
      $flex: false,
      $align: false,
      $grow: false,
      $shrink: false,
      $inline: false,
      $columns: 'flexColumns',
      $gap: 'flexGap',
      flex: 1,
      display: 'inline-flex',
      flexGrid: true,
      $autoFill: {
        flexAutoFill(value) {
          return this.columns ? null : value
        }
      }
    },
    wrapper: {
      $attrs: 'all',
      $flex: 'flex',
      $align: 'flexSelf',
      $grow: 'flexGrow',
      $shrink: 'flexShrink',
      $inline: {
        display(value) {
          return value ? 'inline-flex' : 'flex'
        }
      }
    }
  }
}
